import { Component, Input, OnInit } from '@angular/core';
import { ToolService } from '../../../service/tool.service';

@Component({
  selector: 'app-tool-trace',
  templateUrl: './tool-trace.component.html',
  styleUrls: ['./tool-trace.component.less']
})
export class ToolTraceComponent implements OnInit {

  @Input() currentTool;
  traces: any[] = null;

  constructor(private toolService: ToolService) { }

  ngOnInit(): void {

    this.queryTraceData();

  }

  async queryTraceData(){
    // this.toolService.getToolTraces
    const result = await this.toolService.getToolTraces(this.currentTool.tno);
    if (result === null) {
      return;
    } else {
      this.traces = result;
    }
  }

}
